"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

require("./ProgressBar.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ProgressBar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProgressBar, _Component);

  var _super = _createSuper(ProgressBar);

  function ProgressBar() {
    (0, _classCallCheck2.default)(this, ProgressBar);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ProgressBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          max = _this$props.max,
          value = _this$props.value,
          className = _this$props.className,
          active = _this$props.active;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "primitive-progress-bar"
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.ProgressBar, {
        active: active,
        className: className,
        now: value / max * 100
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        max: _propTypes.default.number,
        value: _propTypes.default.number,
        className: _propTypes.default.string,
        active: _propTypes.default.bool
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        max: 100,
        value: 100,
        className: '',
        active: false
      };
    }
  }]);
  return ProgressBar;
}(_react.Component);

exports.default = ProgressBar;